import React from 'react';
import { Box } from '@material-ui/core';

export default ({ data }) => {
  const { products, advTitle, title: providerName } = data || {};
  const title = `【${advTitle}】 ${providerName}`;

  return (
    <>
      <Box fontWeight="bold">{title}</Box>
      { products.map((product, index) => {
        const { name, price } = product || {};

        return (
          <Box
            alignItems="center"
            display="flex"
            fontWeight="bold"
            justifyContent="space-between"
            key={name}
            fontSize={16}
          >
            <Box>
              {index + 1}
              .
              {' '}
              {name}
            </Box>
            <Box flexShrink={0}>
              原價$
              {price}
            </Box>
          </Box>
        );
      })}
    </>
  );
};
